export default __webpack_public_path__ + "static/media/logo.353da9c1.mp3";